/**
 * @generated SignedSource<<c5401f5cd185bbb119c19aa40903ce58>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProductType = "community_event" | "course" | "membership_plan" | "pathway" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ExperienceAdminDropdownFragment$data = {
  readonly adminCanLearnMode: boolean;
  readonly id: string;
  readonly name: string;
  readonly slug: string;
  readonly type: ProductType;
  readonly " $fragmentSpreads": FragmentRefs<"LearnModeSwitchFragment" | "usePermissionsFragment">;
  readonly " $fragmentType": "ExperienceAdminDropdownFragment";
};
export type ExperienceAdminDropdownFragment$key = {
  readonly " $data"?: ExperienceAdminDropdownFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ExperienceAdminDropdownFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExperienceAdminDropdownFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "adminCanLearnMode",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LearnModeSwitchFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePermissionsFragment"
    }
  ],
  "type": "Product",
  "abstractKey": null
};

(node as any).hash = "af6797ad332bc35695ab841c2f717fee";

export default node;
